import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartCompareHorizontal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-compare-horizontal"><path d="M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 14.25H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 9.25H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 17.25H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 6.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChartCompareHorizontal;
